var CSRFTokenFactory = function ($injector) {
    var factory = {};
    var $q = $injector.get("$q");
    var $http = $injector.get("$http");
    var $rootScope = $injector.get("$rootScope");
    var $window = $injector.get("$window");

    factory.generateCSRF = function () {
        var deferred = $q.defer();

        $http
            .get(__authenticationUrl__ + "rest/nonauth/getCSRFToken")
            .success(function (data, status, headers, config) {
                $rootScope.waiting = true;
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                // TODO: Use logger to log the error message

                deferred.reject(data);
            });

        return deferred.promise;
    };

    factory.saveCSRF = function (data) {
        var deferred = $q.defer();

        $http
            .post(__baseApiUrl__ + "/participant-web-services/rest/nonauth/setCSRFToken", data)
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
            })
            .error(function (data, status, headers, config) {
                // TODO: Use logger to log the error message
                deferred.reject(data);
            });

        return deferred.promise;
    };

    return factory;
};

CSRFTokenFactory.$inject = ["$injector"];
export default CSRFTokenFactory;
